import { createSlice } from '@reduxjs/toolkit'

export const hasFileChangeSlice = createSlice({
    name: 'hasFileChange',
    initialState: {
        hasChanges: false,
    },
    reducers: {
        setHasFileChange: (state, action) => {
            state.hasChanges = action.payload;
        },
    },
})

export const { setHasFileChange } = hasFileChangeSlice.actions;

export const getHasFileChange = (state) => state.hasFileChange.hasChanges;

export default hasFileChangeSlice.reducer